<template>
  <nav :class="className">
    <ul>
      <li v-for="(route, index) in routes" :key="`routes-${index}`">
        <router-link v-if="index !== lastIndex" :to="route.path">{{ route.name }}</router-link>
        <span v-else>{{ route.name }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ElementBreadcrumb',
  computed: {
    ...mapGetters({
      routes: 'breadcrumb/getRoutes'
    }),
    className () {
      return 'breadcrumb'
    },
    lastIndex () {
      return this.routes.length - 1
    }
  }
}
</script>

<style lang="scss">
  .breadcrumb{

    ul{
      @include no-type-list;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    li{
      flex: 0 1 auto;
      color: white;

      &:not(:last-of-type){
        @include icon(icons("chevron-right"), after);
        &::after{
          font-size: 1.2rem;
          color: white;
        }
      }
    }

    a, span{
      color: white;
      font-size: 1.4rem;
      padding: layout("spacing")/2;
      font-weight: font-weights("medium");
    }

    a{
      @include add-transition;

      &.route-active,
      &.route-exact-active{
        color: white;
      }

      &:hover,
      &:active,
      &:focus{
        color: colors("spotlight");
      }
    }
  }
</style>
